<template>
<div>
    <card title="subscriptions" v-loading="loading.teamSubscriptions">
        <h4>Stripe</h4>
        <Table :items="stripe" :columns="columns" :links="stripeLinks" filterProp="plan_name" />
        <h4>PayPal</h4>
        <Table :items="paypal" :columns="columns" :links="paypalLinks" filterProp="plan_name" />
        <div v-if="stiggSubsctiption">
            <h4>Stigg</h4>
            <json-viewer :value="stiggSubsctiption"></json-viewer>
        </div>
    </card>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import Card from '@/components/Card';
import Table from '@/components/Table';
import { getActiveSubscriptions } from '@/services/stigg'

export default {
    data() {
        return {
            columns: [
                {label: 'Subscription ID', prop: 'subscription_id'},
                {label: 'Plan ID', prop: 'plan_id', formatter: item => `${item.plan_id} ${item.is_vip ? '(VIP)' : ''}`},
                {label: 'Is deleted?', formatter: item => item.is_deleted ? 'Deleted' : 'Active'},
            ],
            stripeLinks: [{ label: 'View subscription', to: item => `/customers/stripeSubscription/${item.id}` }],
            paypalLinks: [{ label: 'View subscription', to: item => `/customers/paypalSubscription/${item.id}` }],
            stiggSubsctiption: null,
        };
    },
    async mounted() {
        const { query: id } = this.$route.params;
        this.stiggSubsctiption = await getActiveSubscriptions(id);
    },
    components: {
        Card,
        Table,
    },
    computed: {
        ...mapGetters(['loading', 'teamSubscriptions']),
        stripe() {
            return this.teamSubscriptions.stripe;
        },
        paypal() {
            return this.teamSubscriptions.paypal;
        }
    }
}
</script>

<style scoped>

</style>